var render = function render(){var _vm=this,_c=_vm._self._c;return _c('planejamento-acao-form',{attrs:{"somente-leitura":false,"novo":false,"edicao":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }